import * as React from "react";
import {
  Text,
  StyleSheet,
  View,
  Image,
  ScrollView,
  TouchableOpacity,
  Dimensions,
} from "react-native";
import { useRoute } from "@react-navigation/native";
import Moment from "moment";
import GlobalStyles from "../../components/GlobalStyles";
import UnderLine from "../../components/AnimatedUnderLine";
import MenuBar from "../../components/headers/MenuBar";
import StatusBar from "../../components/headers/StatusBar";
import FooterBarWide from "../../components/footerBarWide";
import BackButton from "../../components/BackButton";

export default function SpendingInsightsDetailScreen(props) {
  const route = useRoute();
  Moment.locale("en");
  const dateConvert = route.params.transaction.dateTime;
  const win = Dimensions.get("window");
  return (
    <View style={GlobalStyles.containerW}>
      <ScrollView>
        <View style={GlobalStyles.backgroundContainer}>
        </View>
        {win.width > 768 ? (
          <View style={GlobalStyles.fullHeaderBarY}>
            <MenuBar data="3" />
            <View style={GlobalStyles.topHeaderTitelContainerForWeb}>
              <View style={[GlobalStyles.headerContainerKLYellow, { alignSelf: "flex-start" }]}>
                <View style={GlobalStyles.headerTextYellowForweb}>
                  <View style={GlobalStyles.backIconContainerForWeb} >
                    <BackButton />
                  </View>
                  <View>
                    <Text style={GlobalStyles.headingStyle}>Transaction Details</Text>
                    <Text style={GlobalStyles.subheaderStyleWeb}>{"\n"}</Text>
                  </View>
                </View>
              </View>
            </View>
          </View>
        ) : (
          <View style={GlobalStyles.fullHeaderBarW}>
            <StatusBar data="BM" />
            <View style={GlobalStyles.headerContainerKL}>
              <View style={[GlobalStyles.headerText]}>
                <Text style={GlobalStyles.headingStyle}>
                  Transaction Details
                </Text>
              </View>
            </View>
          </View>
        )}
        <View style={GlobalStyles.bodyContainerFull}>
          <View style={styles.bodyTop}>
            <View style={styles.underLine}>
              <Text style={styles.yellowLabel}>Date:</Text>
            </View>
            <Text style={styles.bodyStyle}>
              {Moment(
                route.params.transaction.eventDate,
                "YYYY-MM-DDhh:mm:ssZZ"
              ).format("DD/MM/YYYY")}
            </Text>
            <View style={styles.underLine}>
              <Text style={styles.yellowLabel}>Partner/retailer:</Text>
            </View>
            <Text style={styles.bodyStyle}>
              {route.params.transaction.partnerName}
            </Text>
          </View>
          <View style={styles.bodyLower}>
            <View style={styles.underLine}>
              <Text style={styles.grayLabel}>Payment Reference:</Text>
            </View>
            <Text style={styles.bodyStyleBlack}>
              {route.params.transaction.paymentReference}
            </Text>
            <View style={styles.underLine}>
              <Text style={styles.grayLabel}>Time:</Text>
            </View>
            <Text style={styles.bodyStyleBlack}>
              {Moment(
                route.params.transaction.eventDate,
                "YYYY-MM-DDhh:mm:ssZZ"
              ).format("hh:mm a")}
            </Text>
            {/* <View style={([GlobalStyles.centerContent], { paddingTop: 90 })}>
              <TouchableOpacity
                style={GlobalStyles.linkStyle}
                activeOpacity={0.5}
              >
                <Text style={GlobalStyles.TextStyleLink}>
                  CATEGORISE PURCHASE
                </Text>
                <UnderLine />
              </TouchableOpacity>
            </View> */}
          </View>
        </View>
      </ScrollView>
      <View style={GlobalStyles.webFooter}>
        {win.width > 768 ? <FooterBarWide /> : null}
      </View>
    </View>
  );
}

const win = Dimensions.get("window");
var paddingLeft, paddingRight, mybackgroundColor;
const width = win.width;
if (width < 768) {
  paddingLeft = 60;
  paddingRight = 60;
  mybackgroundColor = "red";
} else if (768 < width && width < 880) {
  paddingLeft = 90;
  paddingRight = 90;
  mybackgroundColor = "green";
} else if (width > 880) {
  paddingLeft = 200;
  paddingRight = 200;
  mybackgroundColor = "pink";
}

const styles = StyleSheet.create({
  bodyTop: {
    flexDirection: "column",
    paddingLeft: paddingLeft,
    paddingRight: paddingRight,
    paddingTop: 0,
    paddingBottom: 40,
  },

  bodyLower: {
    flex: 1,
    flexDirection: "column",
    paddingLeft: paddingLeft,
    paddingRight: paddingRight,
    paddingTop: 15,
    paddingBottom: 30,
    backgroundColor: "#ffffff",
    borderBottomWidth: 0,
  },

  hyperLink: {
    fontFamily: "montserrat-bold",
    fontSize: 20,
    textAlign: "center",
    paddingTop: 10,
  },

  bodyStyle: {
    fontFamily: "montserrat-medium",
    fontSize: 16,
    textAlign: "left",
    color: "#ffffff",
    paddingTop: 15,
  },

  bodyStyleBlack: {
    fontFamily: "montserrat-medium",
    fontSize: 16,
    textAlign: "left",
    color: "#000000",
    paddingTop: 15,
  },

  BodyHeaderText: {
    textAlign: "center",
    fontSize: 16,
    fontWeight: "bold",
  },

  yellowLabel: {
    fontFamily: "montserrat-medium",
    fontSize: 16,
    textAlign: "left",
    color: "#FFFFFF",
    paddingTop: 20,
    paddingBottom: 5,
  },

  grayLabel: {
    fontFamily: "montserrat-medium",
    fontSize: 16,
    textAlign: "left",
    color: "#aaaaaa",
    paddingTop: 20,
    paddingBottom: 5,
  },
  underLine: {
    borderBottomColor: "#dddddd",
    borderBottomWidth: 1,
  },
});
